import { z } from 'zod';
/**
 * Aviso de privacidade: o texto que o cliente aceita ao abrir o chat.
 *
 * Mora em configuração, e não no código, porque texto jurídico muda e cada vírgula não
 * deveria custar uma subida de sistema. A versão é o que fica registrado na conversa e na
 * conta — é por ela que se prova, depois, o que a pessoa aceitou.
 */
export const politicaPrivacidadeSchema = z.object({
    /**
     * Identifica a redação. Mudou o texto de forma relevante, muda a versão: quem aceitou a
     * anterior passa a aceitar de novo, e o registro antigo continua apontando para o que
     * valia naquele dia.
     */
    versao: z.string().trim().min(1, 'Informe a versão').max(20),
    texto: z.string().trim().min(50, 'O aviso está curto demais para valer alguma coisa').max(60_000),
});
//# sourceMappingURL=politica.js.map